import { SideBarDeveloperContact } from './side-bar-developer-contact';

export default SideBarDeveloperContact;
